import { css } from 'emotion';
import { space } from '@joykit';
import chroma from 'chroma-js';
import { animationTransition } from '@joykit/variables';
import { getInterUIDynamicMetricCssObject } from 'fonts/Inter-UI/metrics';
import { styled } from '@withjoy/joykit';

export namespace styles {
  export const logoContainer = (stacked: boolean) =>
    css({
      textAlign: stacked ? 'center' : undefined
    });

  export const errorSvg = (tablet: boolean) =>
    css({
      ' svg': {
        maxWidth: tablet ? '90%' : '100%',
        width: 375,
        height: 'auto'
      }
    });

  export const messageContainer = (tablet: boolean) =>
    css({
      margin: space.stack.xl,
      ' > *': {
        ':first-child': {
          fontSize: tablet ? '1.5rem' : space.values.toRem.lg,
          fontFamily: 'PT Serif',
          margin: space.stack.lg,
          lineHeight: 'normal'
        }
        // ':nth-child(2)': {
        //   fontSize: 20,
        //   color: '#999',
        //   margin: space.stack.lg
        // }
      }
    });
  export const contactContainer = css(getInterUIDynamicMetricCssObject(15));

  const refreshButtonHover = chroma('#77728c')
    .darken(0.6)
    .css();

  export const refreshButton = css(getInterUIDynamicMetricCssObject(16), {
    borderRadius: '5px',
    backgroundColor: '#77728c',
    color: 'white',
    minHeight: '48px',
    minWidth: '48px',
    padding: '8px 32px',
    transition: animationTransition('background-color'),
    ':hover': {
      backgroundColor: refreshButtonHover
    }
  });

  const exploreButtonHover = chroma('#999')
    .darken(0.6)
    .css();

  export const exploreIssueButton = css({
    margin: space.stack.md,
    color: '#999999',
    transition: animationTransition('color'),
    ':hover': {
      color: exploreButtonHover
    }
  });

  export const contactButton = css({
    padding: space.squareInset.xs,
    ' span': {
      paddingBottom: '2px',
      borderBottom: '1px solid'
    }
  });
}

export const SvgContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    justify-content: flex-start;
  }
`;

export const Container = styled.div`
  min-height: 100vh;
  padding: 20px 40px;
  max-width: 1920px;
  margin: 0 auto;
  font-family: Inter UI;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: calc(100% - 100px);
  marginTop: 0;
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    min-height calc(100% - 40px);
    margin-top: -72px;
    
  }
`;

export const InfoContainer = styled.div`
  text-align: center;
`;
